/*=========================================================================================
  File Name: moduleDeviceState.js
  Description: Device Module State
==========================================================================================*/


export default {
  device: {},
  devices: [],
  log: [],
}
